<template>
  <div class="bar-2">
    <div class="circule-overlay"></div>
    <router-link
      :to="
        $i18nRoute({
          name: 'NewsDetail',
          params: { slug: item.url },
        })
      "
      class="card card-top"
      v-for="item in list.slice(0, 1)"
      :key="item.id"
    >
      <div class="card__content">
        <div class="opacity-content"></div>
        <div class="card__category">
          <div>{{ item.sub_category.name }}</div>
        </div>
        <div class="card__title">
          <h3 class="title limited-text">
            {{ item.title }}
          </h3>
          <p class="card__brief">{{ item.brief }}</p>
        </div>
        <div class="data-news">
          <span class="day">{{ handleDate(item.pub_date) }},</span>
          <span class="time">{{ handleTime(item.pub_date) }}</span>
        </div>
      </div>

      <div class="card__img">
        <ImageContainer
          class="img"
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
        />
      </div>
    </router-link>
    <div :class="{ anim: desktopWidthNews }">
      <div class="news">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url },
            })
          "
          class="card"
          :class="`card-${index + 1}`"
          v-for="(item, index) in list.slice(1, 6)"
          :key="item.id"
        >
          <div class="card__img">
            <img class="img" :src="item.image.medium" :alt="item.title" />
          </div>
          <div class="card__content">
            <div class="card__category">
              <div>{{ item.sub_category.name }}</div>
            </div>
            <div class="card__title">
              <h3 class="limited-text">
                {{ item.title }}
              </h3>
            </div>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";
import { ref, onMounted, onBeforeUnmount } from "vue";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const desktopWidthNews = ref(false);
    const checkWidth = () => {
      if (typeof window !== "undefined") {
        if (window.innerWidth >= 992) {
          desktopWidthNews.value = true;
        }

        if (window.innerWidth < 992) {
          desktopWidthNews.value = false;
        }
      }
    };
    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function () {
          resizeTimeout = null;
          checkWidth();
          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }
    onMounted(() => {
      if (window.innerWidth >= 992) {
        desktopWidthNews.value = true;
      }
      window.addEventListener("resize", resizeThrottler, false);
      resizeThrottler();
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", resizeThrottler);
    });

    return {
      desktopWidthNews,
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}
.bar-2 {
  width: 90%;
  padding-top: 6rem;
  position: relative;
}
.circule-overlay {
  width: 350px;
  height: 350px;
  position: absolute;
  background: rgba(31, 45, 101, 0.7);
  filter: blur(300px);
  border-radius: 282px;
  right: -25%;
  top: 30%;
}
.card-top {
  display: flex;
  gap: 2rem;
  .card__img {
    flex: 0 0 50%;
    .img {
      padding-bottom: 66%;
    }
  }
  .card__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .card__title {
      .title {
        font-size: 3em;
        line-height: 1.2;
        margin-bottom: 1.5rem;
        --snup: 4;
      }
    }
  }
  .card__brief,
  .data-news {
    width: 80%;
  }
  .data-news {
    text-align: right;
  }
}
.anim {
  &:hover {
    .card {
      flex: 1;
      transform: scale(0.8);
      &:before {
        display: none;
      }
    }
  }
  .news {
    .card {
      &:hover {
        flex: 1.5;
        transform: scale(1.2);
        .card__img {
          opacity: 1;
          transform: scale(0.8);
        }
        .card__content {
          transform: scale(1.1);
        }
      }
      &__img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        // height: 80%;
        text-align: left;
        opacity: 0;
        transition: all 0.4s;
        z-index: -1;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(18, 18, 18, 0.6);
        }
      }
    }
  }
}

.news {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  padding: 4rem 0;
  .card {
    flex: 1;
    text-align: center;
    padding: 6rem 1rem;
    margin: 0.5rem 0;
    position: relative;
    transition: all 0.4s;
    z-index: 2;

    &::before {
      position: absolute;
      content: "";
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(151, 134, 166, 0) 0%,
        #9786a6 51.52%,
        rgba(151, 134, 166, 0) 100%
      );
    }
    &:last-child::before {
      display: none;
    }
  }
}
@media screen and (max-width: 1450px) {
  .card-top {
    .card__content {
      .card__title {
        .title {
          font-size: 1.5em;
          line-height: 1.1;
          --snup: 4;
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .bar-2 {
    padding-top: 5.5rem;
  }
  .card-top {
    .card__content {
      flex: 1;
      .card__title {
        .title {
          font-size: 1.75em;
          line-height: 1.2;
          margin-bottom: 1.5rem;
        }
      }
    }
    .card__brief.limited-text {
      --snup: 6;
    }
    .card__brief,
    .data-news {
      width: 100%;
    }
  }
  .news {
    flex-wrap: wrap;
    .card {
      flex: 1 1 50%;
      padding: 3rem 1rem;
      margin: 0;
      &::before {
        background: linear-gradient(
          180deg,
          rgba(151, 134, 166, 0) 0%,
          #9786a6 100%
        );
      }
      &__img {
        display: none;
      }
    }
    .card-2.card::before {
      right: auto;
      left: 0;
    }
    .card-1.card::before {
      display: block;
      right: 0;
      left: auto;
      top: auto;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(
        90deg,
        rgba(151, 134, 166, 0) 0%,
        #9786a6 100%
      );
    }
    .card-3.card::before {
      display: block;
      right: -1px;
      left: auto;
      // top: 0;
      bottom: auto;
      height: 100%;
      width: 1px;
      background: linear-gradient(
        0deg,
        rgba(151, 134, 166, 0) 0%,
        #9786a6 100%
      );
    }
    .card-4.card::before {
      display: block;
      right: auto;
      left: 0;
      top: -1px;
      height: 1px;
      width: 100%;
      background: linear-gradient(
        270deg,
        rgba(151, 134, 166, 0) 0%,
        #9786a6 100%
      );
    }
    .card-5.card::before {
      bottom: 0;
      content: "";
      display: block;
      bottom: 0;
      top: auto;
      left: 0;
      right: 0;
      height: 1px;
      width: 100%;
      background: linear-gradient(
        90deg,
        rgba(151, 134, 166, 0) 0%,
        #9786a6 51.52%,
        rgba(151, 134, 166, 0) 100%
      );
    }
  }
}

@media screen and (max-width: 767px) {
  .bar-2 {
    padding-top: 4rem;
  }
  .circule-overlay {
    display: none;
  }
  .news {
    .card-1,
    .card-2,
    .card-3,
    .card-4 {
      padding: 1rem 0.5rem;
    }
    .card-5 {
      padding: 1rem;
    }
  }
  .card-top {
    flex-direction: column-reverse;
    .card__content {
      flex: 1;
      .card__title {
        .title {
          font-size: 1.3em;
          line-height: 1.2;
          margin-bottom: 1.5rem;
        }
      }
    }
    .card__brief.limited-text {
      --snup: 6;
    }
    .card__brief,
    .data-news {
      width: 100%;
    }
  }
}
</style>
